module.exports = __webpack_public_path__ + "fonts/nunito-sans-v6-latin-200.ab0fe105.ttf";